import { RecommendBubble, ServiceCategory } from "../types"

const colorHeader = 'Neked való a színtanácsadás, ha'
const colorBubbles: RecommendBubble[] = [
  {
    text: 'szeretnél egy letisztult, jól kombinálható ruhatárat,'
  },
  {
    text: 'nem érted, miért néz ki az a ruha istenien a barátnődön, rajtad meg olyan furán,'
  },
  {
    text: 'van egy csomó ruhád, mégis minden reggel úgy érzed, nincs egy göncöd sem,'
  },
  {
    text: 'rendszeresen érzed úgy, hogy valami nem stimmel a stílusoddal, nem áll össze a vágyott kép.'
  },
]
const bodyHeader = 'Neked való a testalkat tanácsadás, ha'
const bodyBubbles: RecommendBubble[] = [
  {
    text: 'szeretnél egy letisztult, jól kombinálható ruhatárat,'
  },
  {
    text: 'nem érted, miért néz ki az a ruha istenien a barátnődön, rajtad meg olyan furán/bénán,'
  },
  {
    text: 'van egy csomó ruhád, mégis minden reggel úgy érzed, nincs egy göncöd sem,'
  },
  {
    text: 'rendszeresen érzed úgy, hogy valami nem stimmel a stílusoddal, nem áll össze a vágyott kép.'
  },
]
const otherBubbles: RecommendBubble[] = [
  {
    text: 'szeretnél egy letisztult, jól kombinálható ruhatárat,'
  },
  {
    text: 'nem érted, miért néz ki az a ruha istenien a barátnödön, rajtad meg olyan furán/bénán,'
  },
  {
    text: 'van egy csomó ruhád, mégis minden reggel úgy érzed, nincs egy göncöd sem,'
  },
  {
    text: 'rendszeresen érzed úgy, hogy valami nem stimmel a stilusoddal, nem áll össze a vágyott kép.'
  },
]

export const recommendations: {
  [category in ServiceCategory]: {
    header: string
    bubbles: RecommendBubble[]
    picture: string
  }
} = {
  color: {
    header: colorHeader,
    bubbles: colorBubbles,
    picture: 'https://storage.googleapis.com/simonadelstyle/color-recommend.jpg'
  },
  body: {
    header: bodyHeader,
    bubbles: bodyBubbles,
    picture: 'https://storage.googleapis.com/simonadelstyle/body-recommend.jpg'
  },
  other: {
    header: 'otherHeader',
    bubbles: otherBubbles,
    picture: 'https://storage.googleapis.com/simonadelstyle/color-recommend.jpg'
  }
}
